import { useEffect, useState } from "react";

const useIsInWishlist = (gifts, wishlist) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!gifts?.length || !wishlist) return setData(gifts);

    const updatedGifts = gifts.map((gift) => {
      const isMatched = wishlist.find((item) => item?.item?._id === gift?._id);

      if (isMatched) {
        return { ...gift, isInWishlist: true };
      } else {
        return { ...gift, isInWishlist: false };
      }
    });

    setData(updatedGifts);
  }, [wishlist, gifts]);

  return { data };
};

export default useIsInWishlist;
